module.exports = __webpack_public_path__ + "static/img/ll02.cd3c7c01.png";